// Presentation copy for the environment floor (slice-2-onboarding.md §8.2 table).
// `RouteRecommendation.floorReason` (packages/shared/src/model/route.ts:47-48) is an
// internal audit string ("preproduction required by payments, authentication" -
// packages/connections/src/route/recommend.ts:85), not the polished customer copy the
// spec's table calls for - this derives the customer-facing phrase directly from the
// FingerprintSummary flags this lane's RouteCardResponse composes in (src/api/route.ts),
// rather than parsing the audit string (which would silently break if its wording ever
// changes).
import type { FingerprintSummary } from "@nightcrew/shared";

const FLAG_LABELS: readonly { readonly key: keyof FingerprintSummary; readonly label: string }[] = [
  { key: "hasPayments", label: "payments" },
  { key: "hasAuth", label: "sign-in" },
  { key: "hasPii", label: "personal data" },
];

/** Returns the fragment "your app touches X[, Y] and Z", or null when no flag tripped. */
export const formatFloorReason = (fingerprint: FingerprintSummary): string | null => {
  const active = FLAG_LABELS.filter((flag) => fingerprint[flag.key] === true).map(
    (flag) => flag.label,
  );
  // noUncheckedIndexedAccess means array access (and rest-destructure) types as
  // `string | undefined` regardless of the length check above, so `last` is narrowed
  // explicitly rather than asserted.
  const reversed = [...active].reverse();
  const [last, ...restReversed] = reversed;
  if (last === undefined) return null;
  const rest = restReversed.reverse();
  return rest.length === 0
    ? `your app touches ${last}`
    : `your app touches ${rest.join(", ")} and ${last}`;
};
